import { getInitialState } from '../index';
import * as ActionTypes from '../../actions';

import caseReducer from './case-reducer';
import uiReducer from './ui-reducer';
import errorReducer from './error-reducer';
import listReducer from './list-reducer';

const reducers = [uiReducer, caseReducer, errorReducer, listReducer];

export const dataReducer = (state: { [key: string]: any } | undefined, action: { type: string; payload: any }) => {
  if (!state) {
    state = getInitialState().data;
  }
  // SPECIAL CASE: RESET_STORE action just returns next state as initial state.
  // No need to run the other reducers so we just return.
  if (action.type === ActionTypes.RESET_STORE) {
    return getInitialState().data;
  }

  reducers.forEach((reducer) => {
    state = reducer(state, action);
  });
  return state;
};

export default dataReducer;
